export default {
    language: "Italiano",
    StripeSuccess: {
        loading: "Elaborazione del pagamento...",
        successMessage: "Abbonamento attivato con successo!",
        processingError: "Errore di pagamento, contattaci",
    },
    Terms: {
        "tabs": {
            "terms": "Termini di servizio",
            "privacy": "Politica sulla privacy",
            "cookies": "Politica sui cookie"
        },
        "lastUpdated": "Ultimo aggiornamento: 20 maggio 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Introduzione",
                    "description": "Benvenuto su ClixMagicAI. L'utilizzo dei nostri servizi implica l'accettazione di questi termini di servizio. Ti preghiamo di leggerli attentamente."
                },
                {
                    "title": "2. Descrizione del servizio",
                    "description": "ClixMagicAI fornisce strumenti basati su intelligenza artificiale per rimuovere filigrane da immagini, video e PDF. I nostri servizi sono destinati ai seguenti usi legittimi:",
                    "items": [
                        "Rimozione di filigrane dai tuoi contenuti",
                        "Rimozione di filigrane da contenuti per i quali possiedi i diritti appropriati di modifica",
                        "Scopi educativi e di ricerca"
                    ]
                },
                {
                    "title": "3. Responsabilità dell'utente",
                    "description": "Utilizzando ClixMagicAI, accetti di:",
                    "items": [
                        "Caricare solo contenuti di tua proprietà o per i quali possiedi i diritti appropriati di modifica",
                        "Non utilizzare i nostri servizi per scopi illegali o in violazione di qualsiasi legge",
                        "Non tentare di aggirare le nostre misure di sicurezza o le restrizioni d'uso",
                        "Non utilizzare i nostri servizi per violare i diritti di proprietà intellettuale altrui"
                    ]
                },
                {
                    "title": "4. Condizioni dell'account",
                    "description": "Potrebbe essere necessario creare un account per utilizzare alcune funzionalità dei nostri servizi. Per accedere, puoi scegliere di utilizzare un account Google o GitHub. Sei responsabile per:",
                    "items": [
                        "Mantenere la sicurezza del tuo account",
                        "Tutte le attività che avvengono sotto il tuo account",
                        "Fornire informazioni accurate sull'account (inclusi, a titolo esemplificativo, avatar, email, nome utente e ID utente)"
                    ]
                },
                {
                    "title": "5. Servizi gratuiti e a pagamento",
                    "description": "ClixMagicAI offre una quota base gratuita e opzioni flessibili di acquisto punti per accedere alle nostre funzionalità di rimozione filigrana:",
                    "items": [
                        "Quota base: Ogni utente riceverà automaticamente 3 punti gratuiti al giorno, utilizzabili per l'elaborazione dei contenuti",
                        "Regole di consumo punti: La rimozione di filigrane dalle immagini consuma 1 punto per operazione, la rimozione di filigrane dai video consuma 3 punti per operazione",
                        "Acquisto punti: Puoi scegliere di acquistare pacchetti di punti per un maggiore utilizzo; tutti i punti acquistati sono validi permanentemente, senza restrizioni di scadenza",
                        "Politica di rimborso: A causa della natura istantanea e virtuale dei servizi digitali, i punti non possono essere rimborsati una volta acquistati con successo"
                    ]
                },
                {
                    "title": "6. Diritti di proprietà intellettuale",
                    "description": "Il servizio ClixMagicAI, inclusi tutti i software, design e contenuti da noi creati, è nostra proprietà intellettuale. Non è consentito copiare, modificare o creare opere derivate basate sui nostri servizi senza autorizzazione."
                },
                {
                    "title": "7. Limitazione di responsabilità",
                    "description": "ClixMagicAI fornisce il servizio \"così com'è\", senza garanzie di alcun tipo. Non siamo responsabili per eventuali danni derivanti dall'utilizzo dei nostri servizi."
                },
                {
                    "title": "8. Modifiche ai termini",
                    "description": "Possiamo modificare questi termini in qualsiasi momento. L'uso continuato di ClixMagicAI dopo le modifiche ai termini significa che accetti i termini modificati."
                },
                {
                    "title": "9. Cessazione",
                    "description": "Ci riserviamo il diritto di terminare o sospendere il tuo accesso ai nostri servizi immediatamente, senza preavviso, se riteniamo che il tuo comportamento violi questi termini o danneggi altri utenti, noi o terze parti."
                },
                {
                    "title": "10. Legge applicabile",
                    "description": "Questi termini saranno regolati dalle leggi applicabili nel luogo di registrazione della nostra azienda, indipendentemente dalle disposizioni sui conflitti di legge."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Introduzione",
                    "description": "In ClixMagicAI, apprezziamo la tua privacy e ci impegniamo a proteggere i tuoi dati personali. Questa Politica sulla Privacy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni quando utilizzi il nostro sito web e servizi. Accedendo al nostro sito web o utilizzando qualsiasi servizio, accetti le pratiche di elaborazione dei dati descritte in questa politica. Aderiamo alle normative sulla protezione dei dati applicabili."
                },
                {
                    "title": "2. Informazioni che raccogliamo",
                    "description": "Possiamo raccogliere i seguenti tipi di informazioni:",
                    "items": [
                        { "bold": "Informazioni sull'account", "text": "Avatar utente, indirizzo email, nome utente e ID utente forniti durante l'accesso tramite Google o GitHub" },
                        { "bold": "Dati di utilizzo", "text": "Informazioni su come utilizzi i nostri servizi, incluse le funzionalità a cui accedi e i tempi di utilizzo" },
                        { "bold": "Contenuti caricati", "text": "Immagini, video o PDF che carichi per l'elaborazione" },
                        { "bold": "Informazioni di pagamento", "text": "Informazioni di pagamento quando acquisti abbonamenti (elaborate in modo sicuro tramite gateway di pagamento di terze parti come Creem/Stripe/PayPal, conserviamo solo i registri dello stato del pagamento)" },
                        { "bold": "Dati tecnici", "text": "Indirizzo IP, tipo di browser, informazioni sul dispositivo" }
                    ]
                },
                {
                    "title": "3. Come utilizziamo le tue informazioni",
                    "description": "Utilizziamo le tue informazioni per:",
                    "items": [
                        { "text": "Fornire, mantenere e migliorare i nostri servizi" },
                        { "text": "Elaborare e completare le transazioni" },
                        { "text": "Inviare notifiche tecniche e messaggi di supporto" },
                        { "text": "Rispondere ai tuoi commenti e domande" },
                        { "text": "Analizzare i modelli di utilizzo per migliorare l'esperienza utente, ed elaborare i dati personali solo nella misura necessaria per raggiungere gli scopi del servizio" },
                        { "text": "Garantire che il periodo di conservazione dei dati personali non superi il tempo necessario" },
                        { "text": "Prevenire frodi o attività illecite" }
                    ]
                },
                {
                    "title": "4. Sicurezza dei dati",
                    "description": "Implementiamo misure di sicurezza conformi agli standard del settore per proteggere le tue informazioni personali:",
                    "items": [
                        { "text": "Crittografia AES-256 per i file durante la trasmissione e l'archiviazione" },
                        { "text": "Elaborazione di dati sensibili utilizzando un'architettura a conoscenza zero" },
                        { "text": "Revisioni quotidiane dei log di sicurezza e scansioni delle vulnerabilità" },
                        { "text": "L'accesso dei dipendenti segue il principio del privilegio minimo" }
                    ]
                },
                {
                    "title": "5. Condivisione dei dati",
                    "description": "Non vendiamo le tue informazioni personali. Possiamo condividere informazioni con:",
                    "items": [
                        { "bold": "Fornitori di servizi", "text": "Limitata all'elaborazione dei dati necessaria per servizi specifici (come l'archiviazione cloud CloundFlare, gateway di pagamento di terze parti come Creem/Stripe/PayPal), che devono firmare accordi di elaborazione dati" },
                        { "bold": "Requisiti legali", "text": "Quando riceviamo una citazione valida, un ordine del tribunale o altro procedimento legale applicabile a noi" }
                    ]
                },
                {
                    "title": "6. I tuoi diritti",
                    "description": "In base alle leggi vigenti nella tua regione, potresti avere i seguenti diritti:",
                    "items": [
                        { "text": "Accesso a una copia dei tuoi dati personali" },
                        { "text": "Correzione di informazioni inesatte o incomplete" },
                        { "text": "Diritto alla cancellazione dei dati ('diritto all'oblio'), a meno che non abbiamo un motivo legittimo per conservarli" },
                        { "text": "Opposizione o limitazione a determinati tipi di elaborazione dei dati" },
                        { "text": "Diritto alla portabilità dei dati, puoi richiedere il trasferimento dei tuoi dati" }
                    ]
                },
                {
                    "title": "7. Privacy dei minori",
                    "description": "I nostri servizi non sono rivolti a minori di 16 anni. Secondo l'articolo 8 del Regolamento Generale sulla Protezione dei Dati (GDPR), il consenso per i bambini di età inferiore ai 16 anni deve essere dato dai genitori o tutori. Se vieni a conoscenza che un minore di 16 anni ci ha fornito informazioni personali, contattaci immediatamente all'indirizzo support@clixmagic.com."
                },
                {
                    "title": "8. Modifiche a questa politica",
                    "description": "Possiamo aggiornare periodicamente questa politica sulla privacy. Ti informeremo di eventuali modifiche sostanziali pubblicando la nuova politica su questa pagina e aggiornando la data di \"ultimo aggiornamento\". Per modifiche significative, avviseremo gli utenti via email o in altro modo evidente."
                },
                {
                    "title": "9. Contattaci",
                    "description": "Se hai domande su questa politica sulla privacy, contattaci all'indirizzo support@clixmagic.com. Se ritieni che i tuoi dati siano stati trattati in modo improprio o hai dubbi, non esitare a contattarci in qualsiasi momento."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Cosa sono i cookie",
                    "description": "I cookie sono piccoli file di testo che vengono posizionati sul tuo computer o dispositivo mobile quando visiti un sito web. Permettono ai siti web di riconoscere il tuo dispositivo e ricordare se hai visitato il sito in precedenza."
                },
                {
                    "title": "2. Come utilizziamo i cookie",
                    "description": "ClixMagicAI utilizza i cookie per vari scopi:",
                    "items": [
                        { "bold": "Cookie necessari", "text": "Sono necessari per le funzionalità di base del nostro sito web (come gestione delle sessioni e funzioni di sicurezza)" },
                        { "bold": "Cookie di preferenza", "text": "Memorizzano le tue impostazioni e preferenze per migliorare la tua esperienza, ad esempio ricordando il tuo avatar, nome utente ecc. dopo l'accesso tramite Google o GitHub" },
                        { "bold": "Cookie analitici", "text": "Ci aiutano a capire come i visitatori interagiscono con il nostro sito web raccogliendo informazioni anonime" },
                        { "bold": "Cookie di marketing", "text": "Tracciano le tue abitudini di navigazione per offrirti pubblicità pertinenti ai tuoi interessi" }
                    ]
                },
                {
                    "title": "3. Tipi di cookie che utilizziamo",
                    "subsection": [
                        {
                            "title": "3.1 Cookie necessari",
                            "description": "Questi cookie sono necessari per il corretto funzionamento del sito web. Abilitano funzionalità di base come sicurezza, gestione della rete e accesso all'account (incluso l'accesso tramite Google e GitHub). Puoi impostare il tuo browser per bloccare questi cookie, ma alcune parti del sito potrebbero non funzionare correttamente."
                        },
                        {
                            "title": "3.2 Cookie di prestazione e analisi",
                            "description": "Questi cookie ci aiutano a capire come i visitatori interagiscono con il nostro sito web raccogliendo informazioni anonime. Utilizziamo questi dati per migliorare il nostro sito web e i servizi. Questi cookie non raccolgono informazioni che possono identificare un visitatore."
                        },
                        {
                            "title": "3.3 Cookie di funzionalità",
                            "description": "Questi cookie permettono al nostro sito web di ricordare le scelte che fai (come preferenze di lingua o stato di accesso) per fornire funzionalità personalizzate avanzate, come ricordare il tuo stato di accesso tramite Google o GitHub."
                        },
                        {
                            "title": "3.4 Cookie di targeting e pubblicità",
                            "description": "Questi cookie vengono utilizzati per mostrare pubblicità pertinenti ai visitatori e tracciare l'efficacia delle nostre campagne pubblicitarie. Si prega di notare che, poiché il nostro sito web si basa principalmente su accessi di terze parti (Google e GitHub), questo tipo di cookie viene utilizzato principalmente per migliorare l'esperienza utente e non per marketing diretto."
                        }
                    ]
                },
                {
                    "title": "4. Gestione dei cookie",
                    "description": "Puoi controllare e gestire i cookie in vari modi. La maggior parte dei browser web consente di gestire le preferenze dei cookie. Puoi:",
                    "items": [
                        { "text": "Eliminare i cookie dal tuo dispositivo" },
                        { "text": "Bloccare i cookie attivando le impostazioni del browser che ti permettono di rifiutare tutti o alcuni cookie" },
                        { "text": "Impostare il tuo browser per avvisarti quando ricevi un cookie" }
                    ]
                },
                {
                    "title": "5. Cookie di terze parti",
                    "description": "Alcuni cookie vengono posizionati da terze parti sul nostro sito web. Queste terze parti possono includere servizi di analisi (come Google Analytics) e reti pubblicitarie. A causa del funzionamento dei cookie (i cookie possono essere accessibili solo dalla parte che li ha originariamente impostati), non controlliamo l'uso di questi cookie di terze parti né possiamo accedervi. Per gli utenti che accedono tramite Google e GitHub, garantiremo il rispetto delle linee guida sulla privacy di queste piattaforme nel trattamento delle informazioni pertinenti."
                },
                {
                    "title": "6. Aggiornamenti a questa politica sui cookie",
                    "description": "Possiamo aggiornare questa politica sui cookie di tanto in tanto per riflettere cambiamenti nella tecnologia, nei regolamenti o nelle nostre pratiche aziendali. Eventuali modifiche saranno pubblicate su questa pagina e la data di revisione sarà aggiornata."
                },
                {
                    "title": "7. Contattaci",
                    "description": "Se hai domande sul nostro utilizzo dei cookie, contattaci all'indirizzo support@clixmagic.com."
                }
            ]
        }
    },
    UserFeedback: {
        title: "Testimonianze degli utenti",
        feedback: "Ascolta recensioni autentiche di creativi e professionisti di tutto il mondo sulla nostra tecnologia di elaborazione immagini con IA.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Sig. Lin",
                profession: "Editor video e creatore di contenuti",
                rating: 5,
                comment: "Incredibile! ClixMagicAI è velocissimo! Carica un video con filigrana, in pochi minuti ottieni una versione senza filigrana, senza alcuna perdita di qualità. Uno strumento essenziale per la rimozione delle filigrane!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Sig.ra Su",
                profession: "Specialista di marketing sui social media",
                rating: 5,
                comment: "ClixMagicAI ha salvato la mia libreria di contenuti Instagram! Anche le filigrane complesse vengono riconosciute con precisione, l'elaborazione dei bordi è molto più raffinata rispetto ad altri software e i risultati appaiono più naturali."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Sig. Chen",
                profession: "Produttore di contenuti video brevi",
                rating: 5,
                comment: "Rimuovere filigrane con ClixMagicAI è super conveniente, elaboro contenuti TikTok durante il pendolarismo, poi scarico la versione HD non appena arrivo in ufficio! È una benedizione per i professionisti dei media."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Sig. Huang",
                profession: "Designer grafico e direttore creativo visivo",
                rating: 5,
                comment: "Come designer sono molto soddisfatto! Quando gestisco immagini con logo fornite dai clienti, la texture dello sfondo viene ripristinata naturalmente, senza tracce di Photoshop, risparmiando tempo di post-elaborazione."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Sig.ra Emily",
                profession: "Creatrice di contenuti digitali freelance",
                rating: 5,
                comment: "Una scoperta incredibile! Il prezzo dell'abbonamento è molto più conveniente rispetto ad altri prodotti di rimozione filigrana, ma l'effetto di rimozione è in realtà migliore, soprattutto con filigrane trasparenti sfumate."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Sig. Robertson",
                profession: "Sviluppatore di corsi di formazione aziendale",
                rating: 5,
                comment: "ClixMagicAI non richiede installazione, il che è molto conveniente! I computer aziendali non permettono l'installazione di software, ma ora possiamo elaborare i materiali del corso usando solo il browser, ovunque e in qualsiasi momento."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Sig.ra Zhou",
                profession: "Casalinga ed editrice di media comunitari",
                rating: 5,
                comment: "L'interfaccia è così semplice che anche mia nonna potrebbe usarla! Se non hai tempo per imparare software professionali come Photoshop, prova ClixMagicAI - è perfetto per i principianti tecnologici come me! Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Sig. Johnson",
                profession: "Stratega visivo e-commerce",
                rating: 5,
                comment: "ClixMagicAI è potentissimo, può rimuovere immagini, video, piccoli oggetti, persone e testo. Le sue funzionalità sono complete, lo raccomando a tutti~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Sig.ra Fang",
                profession: "Appassionata di fotografia e condivisione di contenuti online",
                rating: 5,
                comment: "Wow~ Finalmente ho trovato uno strumento di rimozione filigrana che non rovina la qualità dell'immagine! È magico come un incantesimo~ L'editing delle foto non è più un problema! Altamente raccomandato!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Sig. Williams",
                profession: "Istruttore di educazione online",
                rating: 5,
                comment: "La funzione di memoria della posizione della filigrana è estremamente utile! Quando elaboro video di corsi in serie, non devo selezionare ripetutamente, risparmiando almeno mezz'ora di lavoro e aumentando notevolmente l'efficienza della mia preparazione didattica."
            }
        ]
    },
    UserDetail: {
        userInfo: {
            emailLabel: "Email",
            createdAt: "Data di creazione",
            noRecord: "Nessun record",
            loginTime: "Orario di accesso",
        },
        orders: {
            title: "Cronologia ordini",
            loading: "Caricamento...",
            refresh: "Aggiorna",
            orderAmount: "Importo",
            points: "Punti",
            createdAt: "Data di creazione",
            orderType: "Tipo",
            status: "Stato",
            noOrders: "Nessun ordine",
            goToSubscription: "Acquista punti",
            freeCredit: "Credito gratuito",
            paidCredit: "Credito a pagamento",
            queryOrderFailed: "Impossibile interrogare l'ordine",
            statusPaid: "Pagato",
            statusPending: "In attesa",
            statusCancelled: "Annullato",
            statusDeactivated: "Disattivato",
            checkoutUrlNotAvailable: "Impossibile ottenere l'URL di pagamento",
            verifyingPayment: "Verifica dello stato del pagamento...",
            paymentSuccess: "Pagamento riuscito",
            paymentPending: "L'ordine è in attesa di pagamento, completa il pagamento",
            paymentFailed: "Pagamento fallito o annullato",
            paymentStatus: "Stato del pagamento",
            paymentStatusDescription: "Hai completato il pagamento?",
            cancelPayment: "Annulla pagamento",
            completedPayment: "Pagamento completato",
            warning: "Attenzione",
            confirmCancelOrder: "Sei sicuro di voler annullare questo ordine? Questa azione non può essere annullata.",
            cancel: "Annulla",
            confirm: "Conferma",
            cancellingOrder: "Annullamento dell'ordine...",
            orderCancelledSuccess: "Ordine annullato",
            cancelOrderFailed: "Impossibile annullare l'ordine",
            checkOrderStatusFailed: "Impossibile verificare lo stato dell'ordine",
            promptClick: "Clicca sullo stato \"In attesa\" per continuare con il pagamento",
        }
    },
    Order: {
        purchasePoints: "Acquista punti",
        subtitle: "Scegli un pacchetto punti adatto per usufruire del servizio di rimozione filigrana di alta qualità",
        loginReminderDesc: "Accedi per selezionare e acquistare punti",
        freeTag: "Gratuito",
        freePlan: "Piano gratuito",
        autoActivated: "Attivazione automatica dopo l'accesso",
        points: "Punti",
        autoIncluded: "Omaggio gratuito",
        discount: "Sconto",
        purchase: "Acquista ora",
        paymentStatusDescription: "Hai completato il pagamento?",
        paymentNotCompleted: "Pagamento non completato",
        queryOrderFailed: "Query stato ordine fallita",
        cancelPayment: "Annulla pagamento",
        completedPayment: "Pagamento completato",
        warning: "Attenzione",
        confirmCancelOrder: "Sei sicuro di voler annullare questo ordine? Questa azione non può essere annullata.",
        cancel: "Annulla",
        confirm: "Conferma",
        selectProductFirst: "Seleziona prima un pacchetto",
        creatingOrder: "Creazione ordine...",
        orderCreated: "Ordine creato con successo",
        createOrderFailed: "Creazione ordine fallita",
        checkoutUrlNotAvailable: "Impossibile ottenere il link di pagamento",
        cancellingOrder: "Annullamento ordine...",
        orderCancelledSuccess: "Ordine annullato",
        cancelOrderFailed: "Annullamento ordine fallito",
        verifyingPayment: "Verifica dello stato del pagamento...",
        paymentSuccess: "Pagamento riuscito",
        paymentPending: "Ordine in attesa di pagamento, completa il pagamento",
        paymentFailed: "Pagamento fallito o annullato",
        checkOrderStatusFailed: "Controllo stato ordine fallito",
        quickStart: "Avvio rapido",
        shortTerm: "Uso a breve termine",
        recommended: "Consigliato",
        bestValue: "Miglior valore",
    },
    Login: {
        title: "Accedi",
        subtitle: "Accesso rapido con account social",
        memberTip: "Accedi per accedere a più funzionalità",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Accedi con GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Accedi con Google"
            }
        ],
        error: {
            serverError: "Errore del server, riprova più tardi",
            networkError: "Errore di rete, controlla la connessione"
        }
    },
    OAuthCallback: {
        loading: "Elaborazione richiesta di accesso",
        pleaseWait: "Attendere, verifica delle informazioni di accesso...",
        error: "Accesso fallito",
        backToHome: "Torna alla homepage",
        success: "Accesso riuscito",
        redirecting: "Reindirizzamento alla homepage..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Prezzi",
            faq: "Domande frequenti",
        },
        login: "Accedi",
        userMenu: {
            account: "Account",
            logout: "Esci",
            credit: "Credito",
            freeCredit: "Gratuito",
            paidCredit: "Acquistato",
            nextUpdate: "Prossimo aggiornamento crediti",
            language: "Lingua",
            theme: "Tema",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "Caratteristiche di ClixMagicAI",
        advs: [
            {
                title: "Motore di riconoscimento AI: Identifica automaticamente elementi intrusivi",
                desc: "Basato su algoritmi di deep learning, identifica automaticamente filigrane, testo, volti ed elementi complessi in immagini/video, senza necessità di marcatura manuale. Supporta formati di Instagram, TikTok e altre piattaforme, con rigorosa protezione dei dati privati.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Rimuovi filigrana"
            },
            {
                title: "Esperto di pulizia immagini: Rimuove loghi/date rapidamente senza perdita di qualità",
                desc: "Rimuove con precisione filigrane di marchi, date di scatto, adesivi e altri elementi di disturbo. L'AI ripristina automaticamente la texture dello sfondo, le immagini dopo l'elaborazione appaiono naturali come l'originale, perfette per i post sui social media.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Rimuovi filigrana"
            },
            {
                title: "Eliminatore di filigrane dinamiche: Rimuove sottotitoli scorrevoli/loghi di piattaforme",
                desc: "Rimuove con un clic le schermate finali di YouTube, le filigrane di TikTok e i testi scorrevoli. L'AI traccia ed elabora ogni fotogramma, producendo video 4K fluidi di alta qualità, supporta formati MP4/MOV e altri formati popolari.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Rimuovi filigrana"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Uno strumento professionale basato sull'AI per rimuovere rapidamente filigrane da immagini, video e PDF con operazioni semplici e risultati naturali.",
        fileTypes: {
            image: 'Rimozione filigrana immagini',
            pdf: 'Rimozione filigrana PDF',
            video: 'Rimozione filigrana video'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Prova gratuita giornaliera", icon: "fa-gift" },
            { id: "imageTag", text: "Rimozione filigrana immagini", icon: "fa-image" },
            { id: "videoTag", text: "Rimozione filigrana video", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Alimentato da AI", icon: "fa-robot" },
            { id: "noRegTag", text: "Accedi e usa", icon: "fa-user-check" },
        ],
        videoPromt: "Prossimamente!",
        videoDesc: "Stiamo sviluppando la rimozione filigrana video per offrirti un'esperienza più potente."
    },
    Footer: {
        social: {
            title: "Contattaci",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Termini legali",
        terms: [
            {
                id: 1,
                title: "Privacy",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Termini di servizio",
                link: "/terms"
            },
            {
                id: 3,
                title: "Policy sui cookie",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Tutti i diritti riservati."
    },
    Task: {
        image: {
            imageSupportText: 'Supporta formati jpg, jpeg, png, webp, heic, heif, massimo 10MB per file',
            imageFileTooLarge: 'Dimensione file oltre il limite (max 10MB)',
            invalidImageType: 'Formato immagine non supportato, carica JPG, JPEG, PNG, WEBP, HEIC o HEIF',
            imageWillCost: 'Costerà: 1 punto',
            hiecSupportText: 'I formati HEIC/HEIF verranno convertiti automaticamente in PNG durante l\'invio',
            hiecSuccess: 'Conversione formato HEIC/HEIF riuscita',
            hiecFailed: 'Conversione formato HEIC/HEIF fallita',
            processingImageTip: 'Elaborazione dell\'immagine, attendere...',
            guide: {
                title: 'Guida utente',
                step1: 'Carica immagine',
                step2: 'Dipingi sull\'area filigrana o lascia che il modello la rilevi automaticamente',
                step3: 'Clicca su invia'
            }
        },
        common: {
            remaining: 'Crediti rimanenti',
            nextUpdate: 'Prossimo aggiornamento crediti',
            handleError: 'Errore nell\'elaborazione del file, prova un altro file',
            uploadFailed: 'Caricamento file fallito',
            dragText: 'Trascina i file qui o',
            clickText: 'clicca per caricare',
            loginRequired: 'Accedi prima di caricare file',
            noRemainingTasks: 'Hai esaurito tutti i tuoi crediti',
            loginNow: 'Accedi ora',
            upgradeNow: 'Acquista crediti ora',
            taskSubmitSuccess: 'Attività inviata con successo',
            taskSubmitError: 'Invio attività fallito',
            taskRetrySuccess: 'Nuovo tentativo inviato con successo!',
            taskRetryError: 'Nuovo tentativo fallito!',
            processing: 'Elaborazione',
            submit: 'Invia',
            waiting: 'In attesa',
            completed: 'Completato',
            failed: 'Fallito',
            cancelled: 'Annullato',
            url_not_found: 'Impossibile ottenere link',
            deleted: 'Eliminato',
            refreshSuccess: 'Elenco attività aggiornato',
            refreshFailed: 'Aggiornamento elenco attività fallito',
            deleteSuccess: 'Attività eliminata con successo',
            deleteFailed: 'Eliminazione attività fallita',
            waitingForCompletion: 'Attendi il completamento dell\'attività corrente prima di riprovare',
            loadOriginalImageFailed: 'Caricamento immagine originale fallito, riprova',
            downloadFailed: 'Download fallito',
            startingDownload: 'Avvio download...',
            noTasks: 'Nessuna attività',
            refresh: 'Aggiorna',
            sort: 'Ordina',
            noFilterTasks: 'Nessuna attività {filter}',
            compare: 'Visualizza confronto',
            originalImage: 'Originale',
            processedImage: 'Elaborata',
            dragToCompare: '👈 Trascina per confrontare 👉',
            cancel: "Annulla",
            delete: "Elimina",
            retry: "Riprova",
            download: "Scarica",
            createAt: "Creato il",
            expiredAt: "Scade il",
        },
        video: {
            videoSupportText: 'Supporta formati mp4, mov, avi, mkv, massimo 100MB per file',
            videoFileTooLarge: 'Dimensione file oltre il limite (max 100MB)',
            invalidVideoType: 'Formato video non supportato, carica MP4, MOV, AVI o MKV',
            videoWillCost: 'Costerà: 3 punti',
            processingVideoTip: 'Elaborazione del video, attendere...',
            guide: {
                step1: 'Carica video',
                step2: 'Seleziona tipo di filigrana e definisci area filigrana',
                step3: 'Clicca su invia'
            },
            annotationTools: 'Strumenti annotazione filigrana',
            selectType: 'Seleziona tipo filigrana',
            deleteAnnotation: 'Elimina annotazione',
            clearAllAnnotations: 'Cancella tutte le annotazioni',
            annotationHelp: 'Aiuto annotazione',
            dragTip: 'Trascina per disegnare area filigrana',
            resizeTip: 'Ridimensiona per adattare alla filigrana',
            moveTip: 'Le annotazioni create possono essere spostate',
            processing: 'Elaborazione',
            submit: 'Invia',
            taskSubmitSuccess: 'Attività inviata con successo',
            taskSubmitError: 'Invio attività fallito',
            retryTaskTip: 'Nuovo tentativo riuscito',
            retryFailed: 'Nuovo tentativo fallito',
            uploadFailed: 'Caricamento fallito',
            staticWatermarkDesc: 'Per filigrane statiche in posizioni fisse',
            normalWatermarkDesc: 'Per normali filigrane fisse',
            dynamicWatermarkDesc: 'Per filigrane dinamiche che cambiano',
            moveWatermarkDesc: 'Per filigrane che necessitano di essere spostate'
        },
    },
    Router: {
        home: "Home",
        terms: "Termini di Servizio",
        privacy: "Politica sulla Privacy",
        cookie: "Politica sui Cookie",
        user: "Centro Utente",
    },
    FAQ: {
        title: "Guida all'uso e domande frequenti di ClixMagicAI",
        prompt: "Hai problemi o domande? Contattaci in qualsiasi momento: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "Cos'è ClixMagicAI e come funziona?",
                answer: "ClixMagicAI è uno strumento avanzato di rimozione filigrane basato sull'intelligenza artificiale. Supporta il riconoscimento automatico di filigrane in immagini e video, e offre anche una funzione di marcatura manuale delle posizioni delle filigrane. Per le immagini, supporta diversi formati di conversione e garantisce output di alta qualità; per i video, può gestire filigrane statiche, dinamiche e persino quelle che cambiano forma."
            },
            {
                id : 2,
                question: "ClixMagicAI offre un utilizzo gratuito?",
                answer: "Sì, offriamo un servizio base gratuito di 3 punti al giorno! Puoi utilizzarli per elaborare immagini (1 punto per operazione) o video (3 punti per operazione). Inoltre, puoi acquistare punti aggiuntivi che rimangono validi permanentemente."
            },
            {
                id : 3,
                question: "Posso acquistare punti aggiuntivi?",
                answer: "Assolutamente! Oltre ai 3 punti gratuiti concessi ogni giorno, puoi ottenere punti aggiuntivi attraverso le nostre opzioni di acquisto. Tutti i punti acquistati rimarranno validi permanentemente, senza data di scadenza."
            },
            {
                id : 4,
                question: "Quali formati di file sono supportati?",
                answer: "Per le immagini, supportiamo i formati PNG, JPEG, JPG, WEBP, HEIC e HEIF, con HEIC e HEIF che verranno automaticamente convertiti in PNG. Per i video, supportiamo vari formati inclusi MP4 e MOV."
            },
            {
                id : 5,
                question: "Come viene protetta la mia privacy?",
                answer: "In ClixMagicAI, diamo grande importanza alla privacy degli utenti. Tutti i file caricati verranno criptati e automaticamente eliminati entro 24 ore dal completamento dell'elaborazione. Non conserviamo alcun file utente o informazioni correlate."
            },
            {
                id : 6,
                question: "Come posso accedere a ClixMagicAI?",
                answer: "Supportiamo l'accesso rapido tramite account GitHub o Google, garantendo la sicurezza del tuo account e semplificando il processo di registrazione."
            },
            {
                id : 7,
                question: "Quanto è veloce l'elaborazione?",
                answer: "Grazie ai nostri server ad alte prestazioni e agli algoritmi AI ottimizzati, la maggior parte dei compiti di rimozione filigrane dalle immagini può essere completata in 10 secondi, mentre la rimozione di filigrane dai video richiede almeno 1 minuto. I tempi effettivi possono variare in base alla dimensione del file e alla complessità."
            },
            {
                id : 8,
                question: "Come sono i risultati dopo l'elaborazione?",
                answer: "I nostri modelli AI sono stati ampiamente addestrati, in grado di rimuovere intelligentemente le filigrane da immagini e video mantenendo al contempo la qualità dei contenuti originali. Sia le filigrane riconosciute automaticamente che quelle marcate manualmente possono essere rimosse efficacemente, garantendo un risultato finale naturale e senza tracce."
            },
            {
                id : 9,
                question: "Quanto dura la validità di ogni attività?",
                answer: "Una volta completata l'attività, i file elaborati saranno conservati su ClixMagicAI per 24 ore per consentire agli utenti di scaricarli. Dopo la scadenza, i file verranno automaticamente eliminati dai nostri server per proteggere la tua privacy."
            },
            {
                id : 10,
                question: "Qual è il limite massimo di dimensione dei file?",
                answer: "Accettiamo immagini con dimensione massima di 10MB e file video con dimensione massima di 100MB. I file che superano questo limite potrebbero necessitare di compressione o trimming prima di essere caricati."
            }
        ]
    }
}